import React, { Component, Fragment } from "react";
// import Footer from "../utilities/Footer";
import AppContext from "../../contexts/AppContext";
// import NoData from "../utilities/NoData";
// import LoadingData from "../utilities/LoadingData";
import { Line, Bar, Doughnut } from "react-chartjs-2";
import Header from "./Header";
import { statistics } from "../../services/dashboard";
class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: {
                getFinancialJobsByMonthes: [],
                getFinancialByMonthes: [],
                sumOfFinancial: [],
                getMonthlyUsers: [],
                usersStates: []
            },
            financialChartData: [],
            financialChartType: "subscriptions"
        };
        this.chartReference = React.createRef();
    }

    updateFinancialChart = type => {
        switch (type) {
            case "subscriptions":
                this.setState({
                    financialChartData: this.state.items
                        .getFinancialJobsByMonthes,
                    financialChartType: type
                });
                break;
            case "jobs":
                this.setState({
                    financialChartData: this.state.items.getFinancialByMonthes,
                    financialChartType: type
                });
                break;
            default:
                this.setState({
                    financialChartData: this.state.items.sumOfFinancial,
                    financialChartType: type
                });
                break;
        }
    };
    componentDidMount() {
        this.context.state.updateMetaData("admin-dashboard");

        statistics()
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    loading: false,
                    financialChartData: response.data.getFinancialJobsByMonthes
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    render() {
        return (
            <Fragment>
                <Header></Header>
                <div className="main-content mt-6">
                    <div className="container dashboard-container">
                        <div className="header bg-dark pb-5">
                            <div className="container-fluid mb-2">
                                <div className="header-body p-4">
                                    <div className="row align-items-end">
                                        <div className="col">
                                            <h6 className="header-pretitle text-secondary">
                                                Overview
                                            </h6>

                                            <h1 className="header-title text-white">
                                                Earnings
                                            </h1>
                                        </div>
                                        <div className="col-auto">
                                            <ul className="nav nav-tabs header-tabs">
                                                <li
                                                    onClick={() =>
                                                        this.updateFinancialChart(
                                                            "subscriptions"
                                                        )
                                                    }
                                                    className="nav-item"
                                                >
                                                    <a
                                                        className={
                                                            this.state
                                                                .financialChartType ===
                                                            "subscriptions"
                                                                ? "nav-link text-center active"
                                                                : "nav-link text-center"
                                                        }
                                                        data-toggle="tab"
                                                    >
                                                        <h6 className="header-pretitle text-secondary">
                                                            Subscriptions
                                                        </h6>
                                                        <h3 className="text-white mb-0">
                                                            {
                                                                this.state.items
                                                                    .sumSubscription
                                                            }
                                                        </h3>
                                                    </a>
                                                </li>
                                                <li
                                                    onClick={() =>
                                                        this.updateFinancialChart(
                                                            "jobs"
                                                        )
                                                    }
                                                    className="nav-item"
                                                >
                                                    <a
                                                        className={
                                                            this.state
                                                                .financialChartType ===
                                                            "jobs"
                                                                ? "nav-link text-center active"
                                                                : "nav-link text-center"
                                                        }
                                                        data-toggle="tab"
                                                    >
                                                        <h6 className="header-pretitle text-secondary">
                                                            Jobs
                                                        </h6>
                                                        <h3 className="text-white mb-0">
                                                            {
                                                                this.state.items
                                                                    .sumJobs
                                                            }
                                                        </h3>
                                                    </a>
                                                </li>
                                                <li
                                                    onClick={() =>
                                                        this.updateFinancialChart(
                                                            "total"
                                                        )
                                                    }
                                                    className="nav-item"
                                                >
                                                    <a
                                                        className={
                                                            this.state
                                                                .financialChartType ===
                                                            "total"
                                                                ? "nav-link text-center active"
                                                                : "nav-link text-center"
                                                        }
                                                        data-toggle="tab"
                                                    >
                                                        <h6 className="header-pretitle text-secondary">
                                                            Total
                                                        </h6>
                                                        <h3 className="text-white mb-0">
                                                            {
                                                                this.state.items
                                                                    .all
                                                            }
                                                        </h3>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="header-footer pl-4 pr-4">
                                    <div className="chart">
                                        <div className="chartjs-size-monitor">
                                            <div className="chartjs-size-monitor-expand">
                                                <div className=""></div>
                                            </div>
                                            <div className="chartjs-size-monitor-shrink">
                                                <div className=""></div>
                                            </div>
                                        </div>
                                        <Line
                                            ref={this.chartReference}
                                            id="headerChart"
                                            className="chart-canvas chartjs-render-monitor"
                                            width={1027}
                                            height={240}
                                            data={{
                                                labels: [
                                                    "January",
                                                    "February",
                                                    "March",
                                                    "April",
                                                    "May",
                                                    "June",
                                                    "July",
                                                    "August",
                                                    "September",
                                                    "October",
                                                    "November",
                                                    "December"
                                                ],
                                                datasets: [
                                                    {
                                                        label: "Total month",
                                                        backgroundColor:
                                                            "transparent",
                                                        borderColor: "#017fe4",
                                                        borderWidth: 1,
                                                        hoverBackgroundColor:
                                                            "#017fe4",
                                                        hoverBorderColor:
                                                            "#017fe4",
                                                        data: this.state
                                                            .financialChartData
                                                    }
                                                ]
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container  mt-n6  mb-2">
                            <div className="row">
                                <div className="col-12 col-xl-8">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h4 className="card-header-title">
                                                        Signups
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="chart">
                                                <div className="chartjs-size-monitor">
                                                    <div className="chartjs-size-monitor-expand">
                                                        <div className=""></div>
                                                    </div>
                                                    <div className="chartjs-size-monitor-shrink">
                                                        <div className=""></div>
                                                    </div>
                                                </div>
                                                <Bar
                                                    id="ordersChart"
                                                    className="chart-canvas chartjs-render-monitor"
                                                    width={627}
                                                    height={250}
                                                    data={{
                                                        labels: [
                                                            "January",
                                                            "February",
                                                            "March",
                                                            "April",
                                                            "May",
                                                            "June",
                                                            "July",
                                                            "August",
                                                            "September",
                                                            "October",
                                                            "November",
                                                            "December"
                                                        ],
                                                        datasets: [
                                                            {
                                                                label:
                                                                    "Total month",
                                                                backgroundColor:
                                                                    "#017fe4",
                                                                borderColor:
                                                                    "#017fe4",
                                                                borderWidth: 1,
                                                                hoverBackgroundColor:
                                                                    "#017fe4",
                                                                hoverBorderColor:
                                                                    "#017fe4",

                                                                barThickness: 10,
                                                                data: this.state
                                                                    .items
                                                                    .getMonthlyUsers
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-4">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h4 className="card-header-title">
                                                        Members
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="chart chart-appended">
                                                <div className="chartjs-size-monitor">
                                                    <div className="chartjs-size-monitor-expand">
                                                        <div className=""></div>
                                                    </div>
                                                    <div className="chartjs-size-monitor-shrink">
                                                        <div className=""></div>
                                                    </div>
                                                </div>
                                                <Doughnut
                                                    id="devicesChart"
                                                    className="chart-canvas chartjs-render-monitor"
                                                    data-toggle="legend"
                                                    data-target="#devicesChartLegend"
                                                    width={276}
                                                    responsive={true}
                                                    maintainAspectRatio={true}
                                                    height={200}
                                                    data={{
                                                        labels: [
                                                            "January",
                                                            "February",
                                                            "March",
                                                            "April",
                                                            "May",
                                                            "June",
                                                            "July",
                                                            "August",
                                                            "September",
                                                            "October",
                                                            "November",
                                                            "December"
                                                        ],
                                                        datasets: [
                                                            {
                                                                label:
                                                                    "Total month",
                                                                backgroundColor:
                                                                    "#017fe4",
                                                                borderColor:
                                                                    "#fff",
                                                                cutoutPercentage: 90,
                                                                hoverBackgroundColor:
                                                                    "#017fe4",
                                                                hoverBorderColor:
                                                                    "#017fe4",
                                                                data: this.state
                                                                    .items
                                                                    .getMonthlyUsers
                                                            }
                                                        ]
                                                    }}
                                                />
                                            </div>

                                            <div
                                                id="devicesChartLegend"
                                                className="chart-legend"
                                            >
                                                <span className="chart-legend-item">
                                                    <i
                                                        className="chart-legend-indicator"
                                                        style={{
                                                            backgroundColor:
                                                                "#2C7BE5"
                                                        }}
                                                    ></i>
                                                    Employers
                                                </span>
                                                <span className="chart-legend-item">
                                                    <i
                                                        className="chart-legend-indicator"
                                                        style={{
                                                            backgroundColor:
                                                                "#A6C5F7"
                                                        }}
                                                    ></i>
                                                    Free members
                                                </span>
                                                <span className="chart-legend-item">
                                                    <i
                                                        className="chart-legend-indicator"
                                                        style={{
                                                            backgroundColor:
                                                                "#D2DDEC"
                                                        }}
                                                    ></i>
                                                    Subscribed members
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6 col-xl">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h6 className="card-title text-uppercase text-muted mb-2">
                                                        Jobs earning
                                                    </h6>

                                                    <span className="h2 mb-0">
                                                        {
                                                            this.state.items
                                                                .sumJobs
                                                        }
                                                    </span>
                                                </div>
                                                <div className="col-auto">
                                                    <span className="h2 fe fe-dollar-sign text-muted mb-0"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h6 className="card-title text-uppercase text-muted mb-2">
                                                        Membership earning
                                                    </h6>

                                                    <span className="h2 mb-0">
                                                        {
                                                            this.state.items
                                                                .sumSubscription
                                                        }
                                                    </span>
                                                </div>
                                                <div className="col-auto">
                                                    <span className="h2 fe fe-dollar-sign text-muted mb-0"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h6 className="card-title text-uppercase text-muted mb-2">
                                                        Total opened jobs
                                                    </h6>

                                                    <span className="h2 mb-0">
                                                        {this.state.items.all}
                                                    </span>
                                                </div>
                                                <div className="col-auto">
                                                    <span className="h2 fe fe-briefcase text-muted mb-0"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h6 className="card-title text-uppercase text-muted mb-2">
                                                        Subscriptions
                                                    </h6>

                                                    <div className="row align-items-center no-gutters">
                                                        <div className="col-auto">
                                                            <span className="h2 mr-2 mb-0">
                                                                {
                                                                    this.state
                                                                        .items
                                                                        .subscribedUserPercentage
                                                                }
                                                                %
                                                            </span>
                                                        </div>
                                                        <div className="col">
                                                            <div className="progress progress-sm">
                                                                <div
                                                                    className="progress-bar"
                                                                    role="progressbar"
                                                                    aria-valuenow={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .subscribedUserPercentage
                                                                    }
                                                                    aria-valuemin="0"
                                                                    aria-valuemax="100"
                                                                ></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <span className="h2 fe fe-clipboard text-muted mb-0"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
Dashboard.contextType = AppContext;
export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/admin/Dashboard.js